var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"pb-[1px] border-b border-solid text-sm border-black cursor-pointer hover:opacity-60 transition-opacity tracking-wider",on:{"click":_vm.showSizeModal}},[_vm._v("\n  "+_vm._s(_vm.$t('Size_Guide'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }